import Vue from 'vue'
import { isNil } from 'lodash'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/misc/register-service-worker'
import '@/misc/handle-network-status'
import { Firebase } from '@/firebase/init'
import '@/misc/handle-apple-install-prompt'
import 'pwacompat'
import '@/plugins/veevalidate'
import '@/plugins/common'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

Firebase.auth().onAuthStateChanged(firebaseUser => {
  const actionToDispatch = isNil(firebaseUser) ? 'logout' : 'login'
  store.dispatch(`authentication/${actionToDispatch}`, firebaseUser)
})

// eslint-disable-next-line no-console
console.info(`
🍱 ESALAB RULES 🍱

👉 https://esalab.usal.es

`)


